
<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header border-bottom-0px text-align-center">

        <div class="row ">
          <div class="col-md-12 text-align-center">
            <label class="label-size-2 font-color-secondary ">IVF Cycle Summary Report</label>
          </div>

        </div>

      </div>
      <div class="card-body padding-top-0px padding-bottom-0px">
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Egg Source Details</label>
          </div>
        </div>
        <div class="row">

          <div class="col-md-3 padding-left-20px">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3">Source: SELF</label>
            </div>

          </div>
          <div class="col-md-3">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3 font-weight-normal">LMP Date: 17-10-2019</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3 font-weight-normal">LMP Cycle: REGLR</label>
            </div>

          </div>
        </div>
       
      </div>
    </div>
  </div>
</div>



